namespace TabAurous.Production {
    export interface WorkOrderBOMRow {
        TransBomId?: number;
        TransItemId?: number;
        RefTransBomId?: number;
        ProductId?: number;
        BomProductId?: number;
        CalcOnId?: number;
        AttributeId?: number;
        Lab?: string;
        CertificateNo?: string;
        Pieces?: number;
        Weight?: number;
        SettingId?: number;
        Purity?: number;
        PureWeight?: number;
        IsCustomerItem?: boolean;
        Markup?: number;
        ProductCode?: string;
        ProductName?: string;
        ItemType?: string;
        CalcOn?: string;
        HasBom?: boolean;
        ItemTypeId?: number;
        ProductTypeId?: number;
        SubCategoryId?: number;
        CategoryId?: number;
        ProductTypeName?: string;
        CategoryName?: string;
        SubCategoryName?: string;
        Attribute?: string;
        CalcUnitId?: number;
        SieveId?: number;
        GroupSieveId?: number;
        KaratId?: number;
        KaratName?: string;
        MetalColorId?: number;
        QualityId?: number;
        ShapeId?: number;
        StoneColorId?: number;
        StoneSizeId?: number;
        StoneCutId?: number;
        StonePolishId?: number;
        StoneSymmetryId?: number;
        StoneFluorescenceId?: number;
        StoneCuletId?: number;
        StoneGirdleId?: number;
        StoneTable?: string;
        StoneDepth?: string;
        TransId?: number;
        BagNo?: string;
        LotNo?: string;
        Line_No?: number;
        CompanyId?: number;
        FinancialYearId?: number;
        UserId?: number;
        RefVoucherId?: number;
        RefTransId?: number;
        RefTransItemId?: number;
        SettingName?: string;
        StoneStatusId?: number;
        StoneStatusName?: string;
    }

    export namespace WorkOrderBOMRow {
        export const idProperty = 'TransBomId';
        export const nameProperty = 'BagNo';
        export const localTextPrefix = 'Production.WorkOrderBOM';
        export const lookupKey = 'Production.WorkOrderBOM';

        export function getLookup(): Q.Lookup<WorkOrderBOMRow> {
            return Q.getLookup<WorkOrderBOMRow>('Production.WorkOrderBOM');
        }
        export const deletePermission = 'Production:WorkOrder:Delete';
        export const insertPermission = 'Production:WorkOrder:Add';
        export const readPermission = '*';
        export const updatePermission = 'Production:WorkOrder:Edit';

        export declare const enum Fields {
            TransBomId = "TransBomId",
            TransItemId = "TransItemId",
            RefTransBomId = "RefTransBomId",
            ProductId = "ProductId",
            BomProductId = "BomProductId",
            CalcOnId = "CalcOnId",
            AttributeId = "AttributeId",
            Lab = "Lab",
            CertificateNo = "CertificateNo",
            Pieces = "Pieces",
            Weight = "Weight",
            SettingId = "SettingId",
            Purity = "Purity",
            PureWeight = "PureWeight",
            IsCustomerItem = "IsCustomerItem",
            Markup = "Markup",
            ProductCode = "ProductCode",
            ProductName = "ProductName",
            ItemType = "ItemType",
            CalcOn = "CalcOn",
            HasBom = "HasBom",
            ItemTypeId = "ItemTypeId",
            ProductTypeId = "ProductTypeId",
            SubCategoryId = "SubCategoryId",
            CategoryId = "CategoryId",
            ProductTypeName = "ProductTypeName",
            CategoryName = "CategoryName",
            SubCategoryName = "SubCategoryName",
            Attribute = "Attribute",
            CalcUnitId = "CalcUnitId",
            SieveId = "SieveId",
            GroupSieveId = "GroupSieveId",
            KaratId = "KaratId",
            KaratName = "KaratName",
            MetalColorId = "MetalColorId",
            QualityId = "QualityId",
            ShapeId = "ShapeId",
            StoneColorId = "StoneColorId",
            StoneSizeId = "StoneSizeId",
            StoneCutId = "StoneCutId",
            StonePolishId = "StonePolishId",
            StoneSymmetryId = "StoneSymmetryId",
            StoneFluorescenceId = "StoneFluorescenceId",
            StoneCuletId = "StoneCuletId",
            StoneGirdleId = "StoneGirdleId",
            StoneTable = "StoneTable",
            StoneDepth = "StoneDepth",
            TransId = "TransId",
            BagNo = "BagNo",
            LotNo = "LotNo",
            Line_No = "Line_No",
            CompanyId = "CompanyId",
            FinancialYearId = "FinancialYearId",
            UserId = "UserId",
            RefVoucherId = "RefVoucherId",
            RefTransId = "RefTransId",
            RefTransItemId = "RefTransItemId",
            SettingName = "SettingName",
            StoneStatusId = "StoneStatusId",
            StoneStatusName = "StoneStatusName"
        }
    }
}
